"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Chunk;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _item = _interopRequireDefault(require("./item"));

function Chunk({
  className,
  items,
  location
}) {
  if (items.length > 0) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, items.map((item, i) => {
      if (typeof item.$$typeof === "symbol") {
        return item;
      } else {
        const {
          to,
          link,
          className,
          label,
          icon,
          onClick
        } = item;
        return /*#__PURE__*/_react.default.createElement(_item.default, {
          to: to,
          link: link,
          location: location,
          key: `navbar-item-${i}`,
          className: className,
          icon: icon,
          onClick: onClick
        }, label);
      }
    }));
  } else {
    return null;
  }
}

Chunk.propTypes = {
  className: _propTypes.default.string.isRequired,
  items: _propTypes.default.array.isRequired,
  location: _propTypes.default.object
};
Chunk.defaultProps = {
  className: "navbar-start",
  items: []
};